import { FormInputSizeEnum, InputSearch, SearchIcon } from '@acceso/design-system';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { Calendar } from '@/components/Calendar/Calendar';
import { useDebouncedCallback } from '@/hooks/use-debounce-callback';
import { useProgramBroadcastFilters } from '@/stores/program-broadcast-filters';

export function BroadcastScheduleProgramHeaderSearch() {
  const { t } = useTranslation();
  const { search, setFilters } = useProgramBroadcastFilters();

  const handleChangeSearch = (newValue: string) => {
    if (newValue !== search) {
      setFilters({ search: newValue });
    }
  };

  const debouncedSearch = useDebouncedCallback(handleChangeSearch, 500);

  return (
    <div
      className="flex flex-wrap items-center gap-2 lg:order-2 lg:gap-4"
      id="parrilla-segments-search"
    >
      <InputSearch
        className={clsx('lg:flex-0 w-[250px] flex-1')}
        value={search ?? ''}
        onChange={newValue => {
          debouncedSearch(newValue);
        }}
        size={FormInputSizeEnum.ExtraSmall}
        placeholder={t('Buscar...')}
        options={{
          leftContent: {
            icon: SearchIcon,
          },
        }}
      />
      <Calendar />
    </div>
  );
}
